import { render, staticRenderFns } from "./ShoppingCartTable.vue?vue&type=template&id=a0cb46dc&scoped=true"
import script from "./ShoppingCartTable.vue?vue&type=script&lang=js"
export * from "./ShoppingCartTable.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartTable.vue?vue&type=style&index=0&id=a0cb46dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb46dc",
  null
  
)

export default component.exports